export default intl => ({
  // googleSiteVerification: 'XXXXXXXXXXXXXXXX',
  schema: 'WebPage',
  defaultTitle: 'LIN3S',
  title: intl.formatMessage({id: 'site.title'}),
  fullTitle: intl.formatMessage({id: 'site.title'}),
  description: intl.formatMessage({id: 'site.meta_description'}),
});
